"use client";

import { BraveheartIcon, JokerIcon } from "@/components/ui/CustomIcons";

interface TeamCardCardsProps {
  jokerCards: number;
  braveheartCards: number;
}

export function TeamCardCards({
  jokerCards,
  braveheartCards,
}: TeamCardCardsProps) {
  return (
    <div className="mt-2.5 flex justify-center gap-3 border-t border-white/10 pt-2.5 md:mt-3 md:gap-4 md:pt-3">
      <div className="flex items-center gap-1.5 rounded-md bg-black/20 px-2 py-1.5 text-sm md:rounded-lg md:px-2.5 md:text-base">
        <JokerIcon className="text-[0.95rem] opacity-80 md:text-base" />
        <span className="font-cinzel font-bold">{jokerCards}</span>
      </div>

      <div className="flex items-center gap-1.5 rounded-md bg-black/20 px-2 py-1.5 text-sm md:rounded-lg md:px-2.5 md:text-base">
        <BraveheartIcon className="text-[0.95rem] opacity-80 md:text-base" />
        <span className="font-cinzel font-bold">{braveheartCards}</span>
      </div>
    </div>
  );
}
